export const DOCUMENTATION_LINK =
	'https://support.atlassian.com/jira-service-management-cloud/docs/create-security-levels-for-issues';
